// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import {Flag} from '../../../../hola/pub/lib/flag';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import country from '/util/country.js';
import {bd_countries} from 'hola_opt';
import anim_styles from '../animation.module.less';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Map} from '../landings/map';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_show_promo} from '../free_proxy/use_show_promo';
import {Lottie} from '../../../../shared/ui/lottie';
import styles from './hero.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';

interface i_hero_props {
    country: string;
    region?: string;
}

const region_name_map = {
    'North America': 'Northern America',
    'Latin America': 'South America',
};

const get_region_countries = (region: string)=>{
    const excluded_countries = ['ps'];
    const countries = bd_countries.by_region[region]?.countries || [];
    return countries.filter(ctr=>!excluded_countries.includes(ctr));
};

const get_flag_country_code = (country_code: string)=>{
    const french_territories = {
        'gp': 'fr', // Guadeloupe
        'bl': 'fr', // Saint Barthelemy
        'mf': 'fr', // Saint Martin
        're': 'fr', // Réunion
        'yt': 'fr', // Mayotte
        'wf': 'fr', // Wallis And Futuna Islands
    };
    return french_territories[country_code?.toLowerCase()] || country_code;
};

export const Location_hero = (props: i_hero_props)=>{
    const {country: location_name, region: us_region_name} = props;
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {width} = use_screen();
    const {show_promo} = use_show_promo();
    const location_info = country.get_location_info(location_name);
    const is_lobby_page = !location_name || location_name === '';
    const is_continent_page = location_info?.type === 'continent';
    const is_country_page = location_info?.type === 'country';
    const is_us_region = !location_name && !!us_region_name;
    const caption = show_promo ? 'Try now for free' : 'Try now';
    let country_code, ip_count, title, subtitle, continent_key, map_countries;
    if (is_lobby_page)
    {
        title = t('Choose from truly worldwide proxies');
        subtitle = `Take advantage of toolip's extensive proxy server IPs to
            bypass geo-restrictions and access global public web data.`;
        country_code = null;
        map_countries = [];
    }
    else if (is_continent_page)
    {
        const continent_name = location_name.replace(/-/g, ' ');
        const {adjective: continent_adjective, key: continent_key_temp} =
            country.get_continent_adjective_form(continent_name);
        continent_key = continent_key_temp;
        const region_key = region_name_map[continent_key] || continent_key;
        const continent_ip_count = bd_countries
            .by_region[region_key]?.count || 0;
        ip_count = continent_ip_count || 0;
        title = width > 950 ? <>
          {ip_count.toLocaleString()} {continent_adjective} <T>Proxies</T>
        </> : <>
          {ip_count.toLocaleString()}<br/>{continent_adjective} <T>Proxies</T>
        </>;
        subtitle = `Access any ${continent_name.charAt(0).toUpperCase() +
            continent_name.slice(1)} website and achieve your goals with ISP
            proxies or datacenters. No barriers & total anonymity!`;
        map_countries = get_region_countries(continent_key);
    }
    else
    {
        const country_obj = country.find_country_by_name(location_name);
        if (!country_obj)
            return <div>/choose Location</div>;
        country_code = country_obj.code == 'uk' ? 'gb' : country_obj.code;
        ip_count = bd_countries && bd_countries[country_code] || 0;
        const region_display_name = us_region_name
            ? us_region_name.replace(/\b\w/g, l=>l.toUpperCase())
            : country_obj.name;
        title = width > 950
            ? <>{ip_count.toLocaleString()} {region_display_name} <T>Proxies</T></>
            : <>{ip_count.toLocaleString()} {region_display_name} <T>Proxies</T></>;
        subtitle = `Access any ${region_display_name} website and
            achieve your goals with ISP proxies or datacenters.
            No barriers & total anonymity!`;
        map_countries = [country_code];
    }
    return <div>
      <section className={styles.hero_section}>
        <div className={cn(styles.hero, theme.container)}>
          <div className={cn(styles.hero_top, anim_styles.hero_showup_1)}>
            <p className={cn(theme.mono14, styles.uptime)}>
              <Lottie autoplay loop width="20px" height="14px"
                src={toolip_img_url('animation/uptime.json')}/>
              <span><T>Uptime: <b>99.9%</b></T></span>
            </p>
          </div>
          <div className={styles.hero_content}>
            <div className={cn(styles.hero_heading,
              anim_styles.hero_showup_2)}>
              {is_country_page && !is_us_region &&
                <Flag country={get_flag_country_code(country_code)}
                  round size={40}/>}
              {is_us_region &&
                <Flag country="us" round size={40}/>}
              <h1 className={theme.H2}>{title}</h1>
            </div>
            <p className={cn(theme.u2, theme.med,
              theme.color_n600, anim_styles.hero_showup_2)}>
              <T>{subtitle}</T>
            </p>
            <div className={cn(styles.mobile_info,
              anim_styles.hero_showup_3)}>
              <div className={styles.info_button}>
                <Button size='lg' cls={styles.button}
                  caption={<>{caption}<Arrow_right/></>}
                  round={false} color='black' to='/dashboard' fit/>
              </div>
            </div>
            <p className={cn(theme.p12, theme.med,
              anim_styles.hero_showup_3)}>
              <T>Free proxies</T> | <T>No credit card required</T>
            </p>
          </div>
          <div className={cn(styles.hero_map, anim_styles.hero_showup_4)}>
            <Map key={country_code || location_name || 'lobby'}
              country_code={is_lobby_page ? null : country_code}
              countries={map_countries}/>
          </div>
        </div>
      </section>
    </div>;
};
